import config from "./Api-config";
import storage from "@/storage/storage";
import PermissionHelper from "@/permissions/PermissionHelper";
import {IAuthToken} from "@/interface/IAuthToken";
import {Api} from "@/services/Api";

let tokenPayloadCache: { token: string, payload: Promise<IAuthToken|null> } | null = null;

// The request interceptor reads the token from storage, so the token must be stored before this runs.
async function fetchTokenPayload(): Promise<IAuthToken|null> {
  try {
    const res = await Api.get("/my/info/v1", undefined, undefined, undefined, true, undefined, true);
    return res?.data?.Success ? <IAuthToken>res.data.Data : null;
  } catch (e) {
    return null;
  }
}

const Auth = {
  async IsLogin() {
    const url = window.location;
    const params = new URLSearchParams(url.search);
    const tokenParam = params.get("token");
    let token:string|null = null;
    let valid:boolean = false;

    if(tokenParam && tokenParam.length>5){
      token = tokenParam;
      await this.SetToken(tokenParam);
      params.delete("token");
      window.location.href = url.origin+url.pathname+"?"+params.toString();
    }else{
      token = await storage.getItem(config.STORAGE_KEYS.TOKEN);
    }
    valid = token !== null;
    if (valid) {
      const isValidToken = await this.validateTokenPayload();
      valid = token !== "" && isValidToken;
    }
    return Promise.resolve(valid);
  },
  async SetToken(token:string) {
    await storage.setItem(config.STORAGE_KEYS.TOKEN, token);
    const payload = await this.GetTokenPayload(token);
    if (payload?.exp) {
      const mainDomain = this.GetMainDomain();
      document.cookie = "token="+token+";expires="+(new Date(payload.exp).toUTCString())+"; path=/; domain="+mainDomain;
    }
  },
  async SignOut() {
    await Api.get("/sign-out/v1");
    await PermissionHelper.removePermission();
    await storage.removeItem(config.STORAGE_KEYS.TOKEN);
    tokenPayloadCache = null;
    await localStorage.removeItem("google-credential");
  },
  async GetTokenPayload(token:string|null=null): Promise<IAuthToken|null> {
    if(token==null){
      token = await storage.getItem<string>(config.STORAGE_KEYS.TOKEN);
    }
    if (token == null || token=="") {
      return null;
    }
    if (tokenPayloadCache == null || tokenPayloadCache.token !== token) {
      tokenPayloadCache = { token, payload: fetchTokenPayload() };
    }
    const payload = await tokenPayloadCache.payload;
    if (payload == null && tokenPayloadCache?.token === token) {
      tokenPayloadCache = null;
    }
    return payload;
  },
  ClearTokenPayloadCache() {
    tokenPayloadCache = null;
  },
  async validateTokenPayload() {
    const currentToken = await Auth.GetTokenPayload();
    if(currentToken != null){
      const authToken = <IAuthToken>currentToken;
      const todayDate = new Date().getTime();
      const expiryDate = new Date(authToken.exp).getTime();
      return expiryDate > todayDate;
    }
    return false;
  },
  GetMainDomain(){
    const hostname = window.location.hostname;
    if(hostname.indexOf(".") == -1){
      return hostname;
    }

    const temps = hostname.split(".");
    if(temps.length > 2){
      return temps[temps.length - 2] + "." + temps[temps.length - 1];
    }
    return temps[temps.length - 1];
  },
};

export default Auth;
